module.exports = __webpack_public_path__ + "static/media/logo-slack.4f038596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-slack.png
// module id = 1309
// module chunks = 17